module.exports = __webpack_public_path__ + "static/img/hotelface.0e04ae9.png";


//////////////////
// WEBPACK FOOTER
// ./static/Brand/BrandGmei/hotelface.png
// module id = 1134
// module chunks = 18